import { TemplateType } from "../types/template";

export const FEED_TEMPLATE_TYPE_STORAGE_KEY = "selectedFeedTemplateType";
export const SDK_TEMPLATE_TYPE_STORAGE_KEY = "selectedSdkTemplateType";

export const TEMPLATE_ROUTE_PREFIXES: Record<TemplateType, string[]> = {
  POST: ["/post"],
  VERTICAL_VIDEO: ["/vertical-video", "/vertical-player"],
  DISCOVER: ["/discover"],
};
